@if (selectSynopticService.isSynopticDisplayed()) {
    <div class="mt-2 ml-2 max-w-60">
        @if (selectSynopticService.depositList().length > 1) {
            <app-select
                class="deposit-zone-select"
                placeholder="selectDeposit"
                [defaultValue]="selectedDepositOption()"
                [label]="'deposit' | transloco"
                [options]="depositOptions()"
                (optionSelected)="onDepositSelection($event[0])" />
        }
        @if (selectSynopticService.synopticZones().length > 1) {
            <app-select
                class="deposit-zone-select"
                label="NRO"
                [defaultValue]="selectedZoneOption()"
                [options]="zoneOptions()"
                [placeholder]="zoneSelectPlaceholder()"
                (optionSelected)="onSynopticZoneSelection($event[0])" />
        }
    </div>
} @else {
    <div class="flex flex-col items-center justify-center h-full gap-2">
        <fa-icon
            class="py-4 text-custom-light-blue"
            size="7x"
            [icon]="['fas', 'diagram-project']" />
        <span class="font-normal text-3xl">
            {{ title() | transloco }}
        </span>
        @if (!homeService.isExternalPage()) {
            <app-synoptic-window-button
                class="my-2"
                [title]="'openInNewWindow'"
                [windowPath]="RoutePathEnum.EXT" />
        }
        <app-select
            class="w-64 m-2"
            [defaultValue]="selectedDepositOption()"
            [options]="depositOptions()"
            [placeholder]="'selectDeposit'"
            (optionSelected)="onDepositSelection($event[0])" />

        @if (selectSynopticService.synopticZones().length > 1) {
            <app-select
                class="w-64 m-2"
                [defaultValue]="selectedZoneOption()"
                [options]="zoneOptions()"
                [placeholder]="zoneSelectPlaceholder()"
                (optionSelected)="onSynopticZoneSelection($event[0])" />
        }
    </div>
}
